import { render, staticRenderFns } from "./EstudiosTable.vue?vue&type=template&id=4b14019e&scoped=true"
import script from "./EstudiosTable.vue?vue&type=script&lang=js"
export * from "./EstudiosTable.vue?vue&type=script&lang=js"
import style0 from "./EstudiosTable.vue?vue&type=style&index=0&id=4b14019e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b14019e",
  null
  
)

export default component.exports